import type { OperationDefinition } from 'flare-chat-core/transport';
import { validateHostOperationInput } from './input.ts';

// Transport commands emitted by declared product actions; backend owns capability admission.
const COMMANDS = Object.freeze([
  'send_message', 'activate_requirement_intake', 'continue_collection', 'generate_analysis',
  'submit_patch_question_answer', 'cancel_patch_question_answer',
  'execute_action',
]);
export const createHostOperationDefinitions = (): OperationDefinition[] => COMMANDS.map((command) => ({
  key: command,
  validateInput: (input) => {
    validateHostOperationInput(input);
    if (input.parameters.command && input.parameters.command !== command) throw new TypeError('Operation command mismatch');
  },
  // Registration admits transport submission; backend authorization remains canonical.
  getAvailability: () => ({ available: true }),
  buildOptions: ({ input }) => {
    validateHostOperationInput(input);
    const { parameters, ...options } = input;
    return { ...options, command, payloadExtra: parameters };
  },
}));
